export default __webpack_public_path__ + "static/media/telegram.2e29b91f.svg";